import { campanhaTipo } from '../../../constants/crm';

export function pathLinkCampanha(campanha) {
  let link = '';
  if (!campanha) return null;
  if (campanha.tipo === campanhaTipo.ChatBot) link = `${process.env.REACT_APP_CHATBOT_URL}`;
  // if (campanha.tipo === campanhaTipo.Formulario) link = `${process.env.REACT_APP_LEADS_URL}`;
  // if (campanha.tipo === campanhaTipo.Formulario2) link = `${process.env.REACT_APP_LEADS2_URL}`;
  if (campanha.tipo === campanhaTipo.FormQ1) link = `${process.env.REACT_APP_LEADQ1_URL}`;
  if (campanha.tipo === campanhaTipo.FormQ2) link = `${process.env.REACT_APP_LEADQ2_URL}`;
  if (campanha.tipo === campanhaTipo.META) link = '';
  return link;
}
